/* eslint-disable prettier/prettier */
import { makeStyles } from '@material-ui/core/styles'
import { purple } from '@material-ui/core/colors'

export default makeStyles(theme => ({
  mine: {
    left: '0'
    // position: 'absolute'
  },
  others: {
    right: '0'
    // position: 'absolute'
  },
  chatContainer: {
    display: 'flex',
    flexDirection: 'row'
  },
  chatAvatar: {
    display: 'flex'
  },
  chatContent: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '20vw'
    // : 0;
    // white-space: pre-line;
  },
  messageContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '5px',
    padding: '10px',
    margin: '5px',
    backgroundColor: '#cfd0d3'
    // overflowY: 'scroll'
  },
  myMessage: {
    border: '1px',
    backgroundColor: '#f9bb78'
  },

  iconChat: {
    marginRight: '10px'
  },
  time: {
    marginLeft: 'auto'
  }
}))